// Клиентская проверка email по тому же правилу, что и сервер
// (`URI::MailTo::EMAIL_REGEXP`): свободная маска `[^\s@]+@[^\s@]+\.[^\s@]+`
// пропускала строки вроде `<script>alert(1)</script>@x.ru`, и форма показывала
// сырой ключ локали из ответа 422 вместо понятной ошибки поля.
export const EMAIL_REGEXP =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

export const isValidEmail = (email) => EMAIL_REGEXP.test(String(email || "").trim())
